import { HashAgencyActions } from "../actions";

const initialState = {
  accesses: {
    rows: [],
    rowCount: 1,
    pageCount: 1,
  },
  totalAccess: {
    rows: [],
    rowCount: 1,
    pageCount: 1,
  },
};

export default function hashAgency(state = initialState, action) {
  switch (action.type) {
    case HashAgencyActions.ACTION_SAVE_TOTAL_HASH_AGENCY:
      return {
        ...state,
        totalAccess: action.payload,
      };
    case HashAgencyActions.ACTION_SAVE_HASH_AGENCY:
      return {
        ...state,
        accesses: action.payload,
      };
    default:
      return state;
  }
}

export function getAccesses(state) {
  return state.hashAgency.accesses;
}

export function getTotalAccesses(state) {
  return state.hashAgency.totalAccess;
}
